import { useState, useEffect } from "react";
import AnswerOptionRadio from "./AnswerOptionRadio";
import LinkButton from "./LinkButton";
import InfoMessage from "./InfoMessage";
import styles from "./CompanyDetails.module.scss";
import scrollToIframe from "../helpers/scrollToIframe";
import "react-widgets/styles.css";
import Combobox from "react-widgets/Combobox";
import { telepulesek } from "../constants";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const days = ["Hé", "Ke", "Sz", "Csü", "Pé", "Szo", "Va"];
const months = ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szept", "Okt", "Nov", "Dec"];

registerLocale("hu", {
  localize: {
    month: (n) => months[n],
    day: (n) => days[n],
  },
  formatLong: {
    date: () => "yyyy.MM.dd.",
  },
});
export default function OstermeloAdditionalInformation() {
  const [nextStepURL, setNextStepURL] = useState(`/result-ostermelo/`);
  const [ste, setSte] = useState("");
  const [bevetelEloszlas, setBevetelEloszlas] = useState("");
  const [szekhely, setSzekhely] = useState("");
  const [alapitasDatum, setAlapitasDatum] = useState(new Date());

  const handleSteChange = (event) => {
    const value = event.target.value;
    setSte(value);
  };

  const handleBevetelEloszlasChange = (event) => {
    const value = event.target.value;
    setBevetelEloszlas(value);
  };

  useEffect(() => {
    scrollToIframe();
  });

  useEffect(() => {
    setNextStepURL(
      `/result/ostermelo?ste=${ste}&bevetelEloszlas=${bevetelEloszlas}&szekhely=${szekhely}&alapitasDatum=${format(alapitasDatum, "yyyy.MM.dd.")}`,
    );
  }, [ste, bevetelEloszlas, szekhely, alapitasDatum]);

  return (
    <div className="container">
      <h1 className={styles.title}>Kérem, válaszoljon az alábbi kérdésekre</h1>
      <h2>Az őstermelő székhelye</h2>
      <Combobox
        className={styles.cityCombobox}
        hideCaret
        hideEmptyPopup
        data={telepulesek}
        placeholder="Kezdje el begépelni a település nevét"
        onChange={(selected) => setSzekhely(selected)}
      />

      <div className={styles.datepickerContainer}>
        <h2>Alapítás dátuma</h2>

        <DatePicker
          className={styles.datepicker}
          selected={alapitasDatum}
          onChange={(date) => setAlapitasDatum(date)}
          dateFormat="yyyy.MM.dd."
          locale={"hu"}
          calendarStartDay={1}
          maxDate={new Date()}
        />
      </div>

      <h2>
        Mekkora igazolható üzemmérettel rendelkeztél ez előző évben? (
        <a href="https://palyaz.hu/ste-kalkulator/" target="_blank" rel="noreferrer">
          STE kalkulátor
        </a>
        )
      </h2>
      <div className={styles.options}>
        <AnswerOptionRadio value="5000_alatt" name="ste" text="5000 STÉ alatt" selected={ste === "5000_alatt"} onChange={handleSteChange} />
        <AnswerOptionRadio
          value="5000_10000_kozott"
          name="ste"
          text="5000-10000 STÉ között"
          selected={ste === "5000_10000_kozott"}
          onChange={handleSteChange}
        />

        <AnswerOptionRadio value="10000_folott" name="ste" text="10000 STÉ felett" selected={ste === "10000_folott"} onChange={handleSteChange} />
      </div>
      <h2>Az előző lezárt üzleti évben az árbevétel milyen százaléka származott mezőgazdasági tevékenységből, az adóbevallás alapján?</h2>
      <div className={styles.options}>
        <AnswerOptionRadio
          value="40"
          name="bevetelEloszlas"
          text="40% vagy annál több"
          selected={bevetelEloszlas === "40"}
          onChange={handleBevetelEloszlasChange}
        />
        <AnswerOptionRadio
          value="40_alatt"
          name="bevetelEloszlas"
          text="kevesebb mint 40%"
          selected={bevetelEloszlas === "40_alatt"}
          onChange={handleBevetelEloszlasChange}
        />
      </div>
      {ste && bevetelEloszlas && telepulesek.includes(szekhely) && alapitasDatum ? <LinkButton url={nextStepURL} text="Tovább" /> : null}
      {!ste || !bevetelEloszlas || !telepulesek.includes(szekhely) || !alapitasDatum ? (
        <InfoMessage text="Kérem, válaszoljon a fenti kérdésekre" />
      ) : null}
    </div>
  );
}
